const handleAttachFile = {
  toastrCreateTitle: 'Added attachment',
  toastrCreateMessage: 'Attachment was successfully added.',
  toastrCreateErrorTitle: 'Error',
  toastrCreateErrorMessage: 'Error adding attachment',

  toastrEditTitle: 'Edited attachment',
  toastrEditMessage: 'The Attachment was successfully edited.',
  toastrEditErrorTitle: 'Error',
  toastrEditErrorMessage: 'Error editing attachment',

  toastrDeleteTitle: 'Attachment Deleted',
  toastrDeleteMessage: 'The Attachment was successfully deleted.',
  toastrDeleteErrorTitle: 'Error',
  toastrDeleteErrorMessage: 'Error deleting attachment',
};

export default handleAttachFile;